export default {
    PROJECT_CLICK: "PROJECT_CLICK",
    PROJECTS_LOADING_ERROR: "PROJECTS_LOADING_ERROR"
}